import React, {Component} from 'react'
import {Button, Dropdown, Grid, GridColumn, GridRow, Icon, List, ListContent, ListItem, Modal, Popup, TextArea} from 'semantic-ui-react'
import {formatDate} from '../cads/format-date'
import {getCadBuyerReviews, updateCadBuyerReviews} from './api'

const addPanelStyle = {
  background: 'rgb(255,255,240)',
  padding: '22px 28px',
  border: '1px solid rgb(235,235,210)',
  borderRadius: '3px'
}

const listStyle = {
  marginTop: '10px',
  border: '1px solid rgb(230,230,230)',
  borderRadius: '3px'
}

const modalContentStyle = {
  maxHeight: 'calc(100vh - 190px)',
  overflowY: 'auto'
}

const itemStyle = {
  padding: '14px 16px',
  position: 'relative'
}

const metaStyle = {
  marginBottom: '5px',
  whiteSpace: 'normal'
}

const markedByStyle = {
  color: 'rgb(115,115,115)',
  fontSize: '12px',
  marginTop: '3px',
  paddingLeft: '25px'
}

const commentStyle = {
  display: 'block',
  maxWidth: '100%',
  color: 'rgb(70,70,70)',
  lineHeight: '1.4',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
  paddingLeft: '25px',
  paddingRight: '90px'
}

const pendingStyle = {
  marginTop: '3px',
  marginRight: '10px',
  display: 'inline-block',
  opacity: 0.3,
  marginBottom: '7px'
}

const pendingElement = (
  <Popup content='You still need to click "Save changes" !' trigger={
    <i style={pendingStyle}>pending</i>
  }/>
)

const errorMessage = (err, fallback) => {
  const errors = err && err.response && err.response.data && err.response.data.errors
  return errors && errors.length > 0 ? errors.join(', ') : fallback
}

const currentUserName = () => {
  let profile = JSON.parse(sessionStorage.getItem('user')) || {}
  return profile.name != null ? profile.name : profile.email
}

const markedBy = (item) => {
  if (item.userName == null || item.userName === '') return null

  return <div style={markedByStyle}>Marked by {item.userName}</div>
}

class CadBuyerReviewsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      reviews: [],
      deleteItems: [],
      addItems: [],
      showAddForm: false,
      reviewDate: '',
      accountName: '',
      comment: ''
    }
  }

  componentDidMount() {
    this.getReviews()
  }

  getReviews = () => {
    getCadBuyerReviews(this.props.cad.i, (err, res) => {
      if (err) {
        alert(errorMessage(err, 'There was an error when trying to get comments.'))
        this.setState({loading: false})
      } else {
        let {cadBuyerReviews} = res.data
        this.setState({loading: false, reviews: cadBuyerReviews})
      }
    })
  }

  showAddForm = () => {
    this.setState({showAddForm: true, reviewDate: '', accountName: '', comment: ''})
  }

  goBack = () => {
    this.setState({showAddForm: false})
  }

  fieldOnChange = (event, {value, name}) => {
    let newState = {}
    newState[name] = value
    this.setState(newState)
  }

  onDateChange = ({currentTarget}) => {
    this.setState({reviewDate: currentTarget.value})
  }

  onCommentChange = (event, {value}) => {
    this.setState({comment: value})
  }

  addComment = () => {
    let {reviewDate, accountName, comment, reviews, addItems} = this.state
    comment = comment.trim()

    if (reviewDate === '' || accountName === '' || comment === '') {
      alert('Please select a date, contact, and comment.')
      return
    }

    let item = {reviewDate, accountName, comment, userName: currentUserName(), pending: true}
    addItems.push(item)
    reviews.push(item)
    reviews = reviews.sort((a, b) => a.reviewDate > b.reviewDate ? 1 : -1)
    this.setState({reviews, addItems})
    this.goBack()
  }

  deleteComment = (deleteItem) => {
    let {reviews, deleteItems} = this.state
    reviews = reviews.filter(item => item !== deleteItem)
    deleteItems.push(deleteItem)
    this.setState({reviews, deleteItems})
  }

  saveComments = () => {
    let {cad, closeModal} = this.props
    let {deleteItems, addItems} = this.state

    updateCadBuyerReviews(cad.i, deleteItems, addItems, (err, res) => {
      if (err) {
        alert(errorMessage(err, 'There was an error when trying to save the comment.'))
      } else {
        let {buyerReviewTotal} = res.data
        window.dispatchEvent(new CustomEvent('buyerReviewUpdated', {
          detail: {cadId: cad.i, buyerReviewTotal}
        }))
        closeModal()
      }
    })
  }

  renderAddForm() {
    let {reviewDate, accountName, comment} = this.state

    return (
      <div style={addPanelStyle}>
        <b style={{textTransform: 'uppercase', borderBottom: '1px solid black'}}>Add comment</b>

        <Grid style={{marginTop: '5px'}}>
          <GridRow>
            <GridColumn width={6}>
              <div style={{marginBottom: '6px'}}>Date</div>
              <input type='date' value={reviewDate} onChange={this.onDateChange} style={{width: '250px'}}/>
            </GridColumn>
            <GridColumn width={10}>
              <div style={{marginBottom: '6px'}}>Contact</div>
              <div style={{width: '300px'}}>
                <Dropdown placeholder='Contact' fluid selection search options={this.props.salesHistoryAccounts}
                  onChange={this.fieldOnChange} name='accountName' value={accountName}
                />
              </div>
            </GridColumn>
          </GridRow>
          <GridRow>
            <GridColumn width={16}>
              <div style={{marginBottom: '6px'}}>Comment</div>
              <TextArea value={comment} onChange={this.onCommentChange} rows={5} style={{width: '100%'}}/>
            </GridColumn>
          </GridRow>
        </Grid>
      </div>
    )
  }

  renderComments() {
    let {reviews} = this.state

    return (
      <div>
        <b style={{borderBottom: '1px solid black'}}>COMMENTS</b>
        <List divided verticalAlign='middle' style={listStyle}>
          {reviews.map(item =>
            <ListItem key={(item.id || 'new') + '-' + item.accountName + '-' + item.reviewDate} style={itemStyle}>
              <ListContent floated='right'>
                {
                  item.pending
                  ?
                  pendingElement
                  :
                  <Button color='red' size='mini' onClick={() => this.deleteComment(item)}>Delete</Button>
                }
              </ListContent>
              <ListContent>
                <div style={metaStyle}>
                  <Icon name='check square outline'/>
                  <b>{item.accountName}</b> - {formatDate(item.reviewDate)}
                </div>
                {markedBy(item)}
                <div style={commentStyle}>{item.comment}</div>
              </ListContent>
            </ListItem>
          )}

          {
            reviews.length === 0
            ?
            <center style={{padding: '22px'}}>No comments yet</center>
            :
            null
          }
        </List>
      </div>
    )
  }

  render() {
    let {closeModal} = this.props
    let {loading, deleteItems, addItems, showAddForm, reviewDate, accountName, comment} = this.state
    let addDisabled = reviewDate === '' || accountName === '' || comment.trim() === ''

    return (
      <React.Fragment>
        <Modal.Content scrolling style={modalContentStyle}>
          {
            showAddForm
            ?
            this.renderAddForm()
            :
            loading
            ?
            <center style={{padding: '10vh'}}>
              <span className='bounce' style={{display: 'inline-block', fontSize: '20px'}}>...</span>
            </center>
            :
            this.renderComments()
          }
        </Modal.Content>
        <Modal.Actions>
          {
            showAddForm
            ?
            <Button basic onClick={this.goBack} style={{float: 'left'}}>
              Back to comments
            </Button>
            :
            <Button primary onClick={this.showAddForm} style={{float: 'left'}}>
              Add comment
            </Button>
          }
          {
            showAddForm
            ?
            <Button id='add-buyer-review-button' primary onClick={this.addComment} disabled={addDisabled}>
              Add comment
            </Button>
            :
            null
          }
          <Button color='black' onClick={closeModal}>
            Cancel
          </Button>
          {
            showAddForm
            ?
            null
            :
            <Button
              content='Save changes'
              labelPosition='right'
              icon='checkmark'
              onClick={this.saveComments}
              disabled={deleteItems.length === 0 && addItems.length === 0}
              positive
            />
          }
        </Modal.Actions>
      </React.Fragment>
    )
  }
}

const cadBuyerReviewsModal = (open, closeModal, cad, salesHistoryAccounts) => {
  if (!open || cad == null) return null

  return (
    <Modal onClose={closeModal} open={open}>
      <Modal.Header>
        Comments
        <div style={{float: 'right', fontSize: '60%', lineHeight: '1.4'}}>
          style number = {cad.s} <br/>
          cad id = {cad.i}
        </div>
      </Modal.Header>
      <CadBuyerReviewsForm cad={cad} closeModal={closeModal} salesHistoryAccounts={salesHistoryAccounts}/>
    </Modal>
  )
}

export {cadBuyerReviewsModal}
